export const ActionTypes = {
  LOADING: "GET__OPTION_CRITERIA_LOADING",
  ERROR: "GET_OPTION_CRITERIA_ERROR",
  SUCCESS: "GET_OPTION_CRITERIA_SUCCESS",
};
